import React from "react"
import { isEqual } from "lodash-es"
import { useDispatch, useSelector } from "react-redux"
import { categories, selectCategory, selectedCategorySlug } from "reduxSlices/taskReportBuilderSlice"
import { CategorySelect } from "shared/selects"

const SolutionSelector = () => {
  const dispatch = useDispatch()
  const categoryOptions = useSelector(categories, isEqual)
  const categorySlug = useSelector(selectedCategorySlug)

  const handleCategoryChange = (slug) => {
    dispatch(selectCategory({ categorySlug: slug }))
  }

  return (
    <CategorySelect
      id="task-report-builder-category-select"
      onChange={handleCategoryChange}
      options={categoryOptions}
      sortBy="label"
      value={categorySlug}
    />
  )
}

export default SolutionSelector
